import { ModalsContext, ModalType } from 'contexts/modal';
import { RealTimeServiceContext } from 'contexts/realTimeService';
import { useCmsPageVisibility } from 'hooks/useCmsPageVisibility';
import { useContext, useEffect, useRef } from 'react';

export const useReferralProgramNotifications = () => {
  const { referralProgram } = useContext(RealTimeServiceContext);
  const { handleModal, modals } = useContext(ModalsContext);

  const lastPayloadHash = useRef<string | null>(null);
  const isReferralProgramVisible = useCmsPageVisibility('referralProgram');

  useEffect(() => {
    // Cleared on logout — drop the hash so the next login is not deduped against it
    if (!referralProgram?.text) {
      lastPayloadHash.current = null;
      return;
    }

    if (modals.length || !isReferralProgramVisible) return;

    const currentHash = JSON.stringify(referralProgram);

    if (currentHash === lastPayloadHash.current) {
      return;
    }

    lastPayloadHash.current = currentHash;

    handleModal(ModalType.ReferralProgram, { stayInSameWindow: true })();
  }, [handleModal, modals.length, referralProgram, isReferralProgramVisible]);
};
